import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface OrganizationType {
  name: string;
  identityValue: string;
  countryIsoCode: string;
  description?: string;
}
const {
  useGet: useOrganization,
  useFind: useOrganizations,
  useCreate: useOrganizationCreation,
  useUpdate: useOrganizationUpdate,
  useDelete: useOrganizationDeletion,
} = getCRUDHooks<OrganizationType>({
  entityName: 'organization',
  getHelper: () => clientApi.getOCClient().helpers.employer.organizations,
  create: ({
    organization,
    context,
  }: {
    organization: Partial<OrganizationType>;
    context: string;
  }) =>
    clientApi
      .getOCClient()
      .helpers.employer.organizations.create(organization, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

export {
  useOrganization,
  useOrganizations,
  useOrganizationCreation,
  useOrganizationUpdate,
  useOrganizationDeletion,
};
